/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PriceFeed, PriceFeedInterface } from "../PriceFeed";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_lastGoodIndex",
        type: "uint256",
      },
    ],
    name: "LastGoodIndexUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_lastGoodPrice",
        type: "uint256",
      },
    ],
    name: "LastGoodPriceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum IPriceFeed.Status",
        name: "newStatus",
        type: "uint8",
      },
    ],
    name: "PriceFeedStatusChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "chainLinkAggregator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "chianLinkIndex",
        type: "address",
      },
    ],
    name: "RegisteredNewOracle",
    type: "event",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FLAG_ARBITRUM_SEQ_OFFLINE",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_PRICE_DEVIATION_FROM_PREVIOUS_ROUND",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_PRICE_DIFFERENCE_BETWEEN_ORACLES",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TARGET_DIGITS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TIMEOUT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_chainlinkOracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_chainlinkIndexOracle",
        type: "address",
      },
    ],
    name: "addOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "adminContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "chainlinkFlags",
    outputs: [
      {
        internalType: "contract FlagsInterface",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "fetchPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastGoodIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastGoodPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "registeredOracles",
    outputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "chainLinkOracle",
        type: "address",
      },
      {
        internalType: "contract AggregatorV3Interface",
        name: "chainLinkIndex",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isRegistered",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_chainlinkFlag",
        type: "address",
      },
      {
        internalType: "address",
        name: "_adminContract",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setAdminContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "status",
    outputs: [
      {
        internalType: "enum IPriceFeed.Status",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b50611635806100206000396000f3fe608060405234801561001057600080fd5b50600436106101375760003560e01c80638429bbf6116100b8578063ace1798e1161007c578063ace1798e146102c4578063c05c5e94146102d7578063e4362b23146102ea578063e4440e0214610352578063f2fde38b14610365578063f56f48f21461037857600080fd5b80638429bbf61461023c5780638da5cb5b1461025c57806390107afe1461026d578063a20baee614610280578063a3f4df7e1461028f57600080fd5b806358a6aa88116100ff57806358a6aa88146101dd5780635ed80d62146101ec57806363a812f91461020c578063715018a6146102215780637c74cb341461022957600080fd5b80631be5c92f1461013c578063200d2ed21461015757806331eab82514610178578063392e53cd146101ab57806345079cb4146101cf575b600080fd5b610144601281565b6040519081526020015b60405180910390f35b60665461016b90600160a01b900460ff1681565b60405161014e9190611200565b61019373a438451d6458044c3c8cd2f6f31c91ac882a6d9181565b6040516001600160a01b03909116815260200161014e565b6065546101bf90600160a01b900460ff1681565b604051901515815260200161014e565b61014466b1a2bc2ec5000081565b6101446706f05b59d3b2000081565b6101446101fa36600461123f565b60696020526000908152604090205481565b61021f61021a36600461123f565b610381565b005b61021f6103e9565b61021f61023736600461125a565b61041f565b61014461024a36600461123f565b60686020526000908152604090205481565b6033546001600160a01b0316610193565b61021f61027b36600461129d565b6105f7565b610144670de0b6b3a764000081565b6102b760405180604001604052806009815260200168141c9a58d95199595960ba1b81525081565b60405161014e91906112d0565b6101446102d236600461123f565b61072b565b606654610193906001600160a01b031681565b61032a6102f836600461123f565b606760205260009081526040902080546001909101546001600160a01b0391821691811690600160a01b900460ff1683565b604080516001600160a01b03948516815293909216602084015215159082015260600161014e565b606554610193906001600160a01b031681565b61021f61037336600461123f565b610946565b61014461384081565b6033546001600160a01b031633146103b45760405162461bcd60e51b81526004016103ab90611325565b60405180910390fd5b6001600160a01b0381166103c757600080fd5b606680546001600160a01b0319166001600160a01b0392909216919091179055565b6033546001600160a01b031633146104135760405162461bcd60e51b81526004016103ab90611325565b61041d60006109e1565b565b6033546001600160a01b031633148061044257506066546001600160a01b031633145b6104835760405162461bcd60e51b815260206004820152601260248201527124b73b30b634b2102832b936b4b9b9b4b7b760711b60448201526064016103ab565b604080516060810182526001600160a01b0380851682528084166020808401918252600184860181815289851660009081526067909352958220945185549085166001600160a01b0319909116178555915193909101805494511515600160a01b026001600160a81b0319909516939092169290921792909217909155829082908080806105118686610a33565b93509350935093506105238484610ae8565b158015610536575061053484610b0b565b155b6105525760405162461bcd60e51b81526004016103ab9061135a565b61055c8282610ae8565b15801561056f575061056d82610b0b565b155b61058b5760405162461bcd60e51b81526004016103ab9061135a565b6105958985610b2e565b506105a08983610b52565b50604080516001600160a01b038b811682528a8116602083015289168183015290517f485482cc3527e7dd8c60b7843a1fec9b32f41b99cde14992684afe84b67275f09181900360600190a1505050505050505050565b600054610100900460ff166106125760005460ff1615610616565b303b155b6106795760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084016103ab565b600054610100900460ff1615801561069b576000805461ffff19166101011790555b606554600160a01b900460ff16156106b257600080fd5b6106bb83610b76565b6106c482610b76565b6065805460ff60a01b1916600160a01b1790556106df610c1f565b60668054606580546001600160a01b0319166001600160a01b038781169190911790915584166001600160a81b03199091161790558015610726576000805461ff00191690555b505050565b6001600160a01b03811660009081526067602052604081206001810154600160a01b900460ff1661079e5760405162461bcd60e51b815260206004820152601960248201527f4f7261636c65206973206e6f742072656769737465726564210000000000000060448201526064016103ab565b805460018201546000918291829182916107c4916001600160a01b039081169116610a33565b6001600160a01b038b16600090815260686020908152604080832054606990925282205495995093975091955093509091906108008787610ae8565b8061080f575061080f87610b0b565b9050600061081d8686610ae8565b8061082c575061082c86610b0b565b90506000606654600160a01b900460ff16600181111561084e5761084e6111ea565b14156108e457818061085d5750805b156108a95781610874576108718b89610b2e565b93505b80610886576108838b87610b52565b92505b6108906001610c56565b61089a8484610cba565b9b9a5050505050505050505050565b6108b38888610cd8565b156108c25761089a8484610cba565b6108cc8b89610b2e565b93506108d88b87610b52565b925061089a8484610cba565b6001606654600160a01b900460ff166001811115610904576109046111ea565b14156108905781158015610916575080155b15610925576109256000610c56565b81610937576109348b89610b2e565b93505b80610890576108d88b87610b52565b6033546001600160a01b031633146109705760405162461bcd60e51b81526004016103ab90611325565b6001600160a01b0381166109d55760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016103ab565b6109de816109e1565b50565b603380546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b610a3b6111bc565b610a436111bc565b610a4b6111bc565b610a536111bc565b610a5c86610d5f565b9350610a718685600001518660800151610ee9565b92506001600160a01b03851615610aa757610a8b85610d5f565b9150610aa08583600001518460800151610ee9565b9050610adf565b50506040805160a0810182526001808252670de0b6b3a764000060208301524292820192909252606081019190915260126080820152805b92959194509250565b6000610af383610fab565b80610b025750610b0282610fab565b90505b92915050565b6000613840610b2783604001514261101290919063ffffffff16565b1192915050565b600080610b468360200151846080015160ff1661101e565b9050610b028482611081565b600080610b6a8360200151846080015160ff1661101e565b9050610b0284826110da565b6001600160a01b038116610bcc5760405162461bcd60e51b815260206004820152601e60248201527f4163636f756e742063616e6e6f74206265207a65726f2061646472657373000060448201526064016103ab565b803b80610c1b5760405162461bcd60e51b815260206004820181905260248201527f4163636f756e7420636f64652073697a652063616e6e6f74206265207a65726f60448201526064016103ab565b5050565b600054610100900460ff16610c465760405162461bcd60e51b81526004016103ab906113aa565b610c4e611127565b61041d61114e565b6066805482919060ff60a01b1916600160a01b836001811115610c7b57610c7b6111ea565b02179055507f5c57579a8214fe4f710c1c56fa829f045b9fa6d225a744225a30c32188064d4e81604051610caf9190611200565b60405180910390a150565b6000610b02670de0b6b3a7640000610cd2858561117e565b9061118a565b600080610cf08460200151856080015160ff1661101e565b90506000610d098460200151856080015160ff1661101e565b90506000610d178383611196565b90506000610d2584846111ac565b90506000610d4982610cd2670de0b6b3a7640000610d438388611012565b9061117e565b6706f05b59d3b200001098975050505050505050565b610d676111bc565b606554604051631abf23ff60e11b815273a438451d6458044c3c8cd2f6f31c91ac882a6d9160048201526001600160a01b039091169063357e47fe90602401602060405180830381865afa158015610dc3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610de791906113f5565b15610df157919050565b816001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610e4b575060408051601f3d908101601f19168201909252610e4891810190611417565b60015b610e5457919050565b60ff166080820152816001600160a01b031663feaf968c6040518163ffffffff1660e01b815260040160a060405180830381865afa925050508015610eb6575060408051601f3d908101601f19168201909252610eb391810190611451565b60015b610ebf57919050565b506001600160501b039093168452506020830152604082015260016060820152919050565b919050565b610ef16111bc565b6001600160501b038316610f0457610fa4565b604051639a6fc8f560e01b81526001600160501b0360001985011660048201526001600160a01b03851690639a6fc8f59060240160a060405180830381865afa925050508015610f71575060408051601f3d908101601f19168201909252610f6e91810190611451565b60015b610f7a57610fa4565b506001600160501b039093168452506020830152604082015260ff82166080820152600160608201525b9392505050565b60008160600151610fbe57506001919050565b81516001600160501b0316610fd557506001919050565b60408201511580610fe95750428260400151115b15610ff657506001919050565b600082602001511361100a57506001919050565b506000919050565b6000610b0282846114b7565b60008060128310611050576110496110376012856114b7565b61104290600a6115b2565b859061118a565b9050610b02565b6012831015610b02576110796110678460126114b7565b61107290600a6115b2565b859061117e565b949350505050565b6001600160a01b03821660008181526068602052604090819020839055517f9a696fe6a955b23852e2b245b6847dfda7d8944623d9b42628e087344ad17963906110ce9084815260200190565b60405180910390a25050565b6001600160a01b03821660008181526069602052604090819020839055517f778c230737afad410102ee1cf60b9da20877a6212f0abc736f8e018596291d80906110ce9084815260200190565b600054610100900460ff1661041d5760405162461bcd60e51b81526004016103ab906113aa565b600054610100900460ff166111755760405162461bcd60e51b81526004016103ab906113aa565b61041d336109e1565b6000610b0282846115be565b6000610b0282846115dd565b60008183106111a55781610b02565b5090919050565b6000818310156111a55781610b02565b6040805160a08101825260008082526020820181905291810182905260608101829052608081019190915290565b634e487b7160e01b600052602160045260246000fd5b602081016002831061122257634e487b7160e01b600052602160045260246000fd5b91905290565b80356001600160a01b0381168114610ee457600080fd5b60006020828403121561125157600080fd5b610b0282611228565b60008060006060848603121561126f57600080fd5b61127884611228565b925061128660208501611228565b915061129460408501611228565b90509250925092565b600080604083850312156112b057600080fd5b6112b983611228565b91506112c760208401611228565b90509250929050565b600060208083528351808285015260005b818110156112fd578581018301518582016040015282016112e1565b8181111561130f576000604083870101525b50601f01601f1916929092016040019392505050565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b60208082526030908201527f5072696365466565643a20436861696e6c696e6b206d75737420626520776f7260408201526f1ada5b99c8185b990818dd5c9c995b9d60821b606082015260800190565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b60006020828403121561140757600080fd5b81518015158114610b0257600080fd5b60006020828403121561142957600080fd5b815160ff81168114610b0257600080fd5b80516001600160501b0381168114610ee457600080fd5b600080600080600060a0868803121561146957600080fd5b6114728661143a565b94506020860151935060408601519250606086015191506114956080870161143a565b90509295509295909350565b634e487b7160e01b600052601160045260246000fd5b6000828210156114c9576114c96114a1565b500390565b600181815b808511156115095781600019048211156114ef576114ef6114a1565b808516156114fc57918102915b93841c93908002906114d3565b509250929050565b60008261152057506001610b05565b8161152d57506000610b05565b8160018114611543576002811461154d57611569565b6001915050610b05565b60ff84111561155e5761155e6114a1565b50506001821b610b05565b5060208310610133831016604e8410600b841016171561158c575081810a610b05565b61159683836114ce565b80600019048211156115aa576115aa6114a1565b029392505050565b6000610b028383611511565b60008160001904831182151516156115d8576115d86114a1565b500290565b6000826115fa57634e487b7160e01b600052601260045260246000fd5b50049056fea2646970667358221220e11e28176294c7e3117e893dd5b6d03f1613d419f8020a9f0bde14d3e641a65864736f6c634300080a0033";

type PriceFeedConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PriceFeedConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PriceFeed__factory extends ContractFactory {
  constructor(...args: PriceFeedConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<PriceFeed> {
    return super.deploy(overrides || {}) as Promise<PriceFeed>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): PriceFeed {
    return super.attach(address) as PriceFeed;
  }
  override connect(signer: Signer): PriceFeed__factory {
    return super.connect(signer) as PriceFeed__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PriceFeedInterface {
    return new utils.Interface(_abi) as PriceFeedInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceFeed {
    return new Contract(address, _abi, signerOrProvider) as PriceFeed;
  }
}
